import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';
import {
  Button,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  Divider,
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';
import { PdsButton } from '@/modules/perseo-billing/ui/react/src/components/gamma';
import { redirectToUrl } from '@/modules/perseo-billing/utils/window';

import { ModalWrapper } from '../../components';
import { setLeavingPayment } from '../../store/slices/billing';

export const ModalIsLeavingPayment = () => {
  const dispatch = useAppDispatch();

  const leavingPayment = useAppSelector(
    (state) => state.billing.leavingPayment
  );

  const [isMounted, setIsMounted] = useState<boolean>(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);
  const modalContent = (
    <ModalWrapper
      size="sm"
      open={!!leavingPayment}
      onClose={() => dispatch(setLeavingPayment(''))}
      roundedType="FIXED_BOTTOM"
    >
      <Card p={16}>
        <CardHeader
          action={
            <Button
              onClick={() => dispatch(setLeavingPayment(''))}
              icon="CloseIcon"
            />
          }
          title={
            <div className="co-flex co-gap-8px">
              <Icon
                icon="InputWarningIcon"
                width={24}
                height={24}
                className="co-min-w-24px co-min-h-24px"
              />
              <Typography size="h3" weight="semibold">
                ¿Quieres salir del proceso de compra?
              </Typography>
            </div>
          }
        />
        <Divider />
        <CardContent pt={16}>
          <Typography size="h4">
            Se perderá toda la información del despacho.
          </Typography>
        </CardContent>

        <CardFooter
          className={
            'co-flex co-justify-end co-gap-8px co-flex-col-reverse lg:co-flex-row lg:co-pt-4'
          }
        >
          <PdsButton
            feedback="success"
            typology="terciary"
            onClick={() => dispatch(setLeavingPayment(''))}
            type="button"
          >
            Volver
          </PdsButton>
          <Button
            pl={32}
            pr={32}
            variant="contained"
            color="primary"
            type="button"
            onClick={() => {
              if (!leavingPayment) return;
              redirectToUrl(leavingPayment);
            }}
          >
            Salir
          </Button>
        </CardFooter>
      </Card>
    </ModalWrapper>
  );

  const modalElement = document.getElementById('modal-leaving-payment');
  if (!isMounted) return null;
  if (!modalElement) return null;

  return createPortal(modalContent, modalElement);
};
